import { API } from "../../constants/APIConstants";
import { callAPI } from "../../config/AxiosTemplate";

// MC-5742: the worklist of pending customer entry level requests,
// optionally filtered by raised-on date range (fd/td) and/or seller (uid)
export const getEntryLevelRequestsAction = (requestData, callback) => {
  callAPI(
    "getEntryLevelRequests",
    API.getEntryLevelRequests,
    "GET",
    requestData,
    (apiResponse) => {
      callback(apiResponse);
    }
  );
};

// MC-5742: approve or reject a customer's pending entry level request
export const decideEntryLevelRequestAction = (requestData, callback) => {
  callAPI(
    "decideEntryLevelRequest",
    API.decideEntryLevelRequest,
    "POST",
    requestData,
    (apiResponse) => {
      callback(apiResponse);
    }
  );
};
